module.exports = __webpack_public_path__ + "static/ft03-da492b3a89bac9044a1912b9436c9eff.jpg";